import styles from "./AuthenticationAction.module.scss";
import React from "react";
import Form from "react-bootstrap/Form";
import useAuthenticationAction, {
  ACTION_INVALID,
  ACTION_RECOVER_EMAIL,
  ACTION_RESET,
  ACTION_VERIFY_EMAIL
} from "./useAuthenticationAction";

const AuthenticationAction = () => {
  const {
    t,
    resetting,
    action,
    error,
    email,
    handleReset,
    password,
    passwordConfirm,
    updatePassword,
    updatePasswordConfirm
  } = useAuthenticationAction();

  if (action === ACTION_RESET) {
    return <div className={styles.container}>
      <div className={styles.title}>{t("text_reset_password")}</div>

      {error && <div className={styles.error}>{error}</div>}

      <Form onSubmit={handleReset} className={styles.form}>
        <Form.Group className="mb-2" controlId="reset-email">
          <Form.Control
            type="text"
            name="register-email"
            value={email}
            placeholder={t("placeholder_email")}
            disabled
          />
        </Form.Group>
        <Form.Group className="mb-2" controlId="reset-password">
          <Form.Control
            type="password"
            name="reset-password"
            value={password}
            onChange={updatePassword}
            placeholder={t("placeholder_password")}
            disabled={resetting}
          />
        </Form.Group>
        <Form.Group className="mb-2" controlId="reset-password-confirm">
          <Form.Control
            type="password"
            name="reset-password-confirm"
            value={passwordConfirm}
            onChange={updatePasswordConfirm}
            placeholder={t("placeholder_password_confirmation")}
            disabled={resetting}
          />
        </Form.Group>

        <button className={styles.submitBtn} type="submit" disabled={resetting}>{t("btn_reset_password")}</button>
      </Form>
    </div>;
  } else if (action === ACTION_VERIFY_EMAIL) {
    return <div className={styles.container}>{t("text_email_verified")}</div>
  } else if (action === ACTION_RECOVER_EMAIL) {
    return <div className={styles.container}>{t("text_email_recovered")}</div>
  } else if (action === ACTION_INVALID) {
    return <div className={styles.container}>{t("text_invalid_link")}</div>
  } else {
    return null;
  }
};

export default AuthenticationAction;
